<script setup lang="ts">
import { computed, inject } from 'vue';

import { OVERLAY_HOST } from './overlay-host';

defineProps<{
  disabled?: boolean;
}>();

// Элемент вне открытого окна неактивен, поэтому попап внутри окна остаётся в его dialog.
const host = inject(OVERLAY_HOST, null);
const target = computed(() => host?.value ?? 'body');
</script>

<template>
  <Teleport
    :to="target"
    :disabled="disabled"
  >
    <slot />
  </Teleport>
</template>
